/* =======================================================
   OPEN FILTER DRAWE LOGIC
======================================================= */
document.addEventListener('DOMContentLoaded', () => {
    const filterButtons = document.querySelectorAll('.ck-filter-btn[data-filter-handle]');
    const facets = document.querySelectorAll('.ck-details[data-filter-handle]');
    const drawer = document.getElementById('FacetDrawer');
  
    filterButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const handle = btn.dataset.filterHandle;
  
        drawer.setAttribute('open', '');
  
        facets.forEach((facet) => facet.classList.remove('active'));
        const target = document.querySelector(`.ck-details[data-filter-handle="${handle}"]`);
        if (target) target.classList.add('active');
      });
    });
  });
  
  document.addEventListener('DOMContentLoaded', initCkFilters);
  window.addEventListener('pageshow', initCkFilters);
  document.addEventListener('DOMContentLoaded', initCkSubmenuFilters);
  
  /* =======================================================
     SUBCATEGORIES FILTER BY TAG
  ======================================================= */
  function initCkSubmenuFilters() {
    const submenuBtns = document.querySelectorAll('.ck-submenu-btn[data-tag]');
    const mainSubmenuBtn = document.querySelector('.ck-submenu-btn__all');
    if (!submenuBtns.length) return;
  
    const normalizeTag = (val) =>
      val ? val.toLowerCase().trim().replace(/\s+/g, '-') : '';
  
    const currentUrl = new URL(window.location.href);
    const { handle: collectionHandle, tags: currentTags } = extractCollectionInfo(currentUrl.pathname);
  
    let anyTagActive = false;
  
    submenuBtns.forEach((btn) => {
      const rawTag = btn.dataset.tag || '';
      const tag = normalizeTag(rawTag);
  
      if (currentTags.includes(tag)) {
        btn.classList.add('is-active');
        anyTagActive = true;
      } else {
        btn.classList.remove('is-active');
      }
  
      btn.addEventListener('click', (e) => {
        e.preventDefault();
  
        const newPath = `/collections/${collectionHandle}/${tag}#ck-collection-filters`;
        window.location.href = newPath;
      });
    });
  
    if (mainSubmenuBtn) {
      if (anyTagActive) {
        mainSubmenuBtn.classList.remove('is-active');
      } else {
        mainSubmenuBtn.classList.add('is-active');
      }
  
      mainSubmenuBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const newPath = `/collections/${collectionHandle}#ck-collection-filters`;
        window.location.href = newPath;
      });
    }
  
    function extractCollectionInfo(path) {
      const parts = path.split('/').filter(Boolean);
      const collectionIndex = parts.indexOf('collections');
      const handle = parts[collectionIndex + 1] || 'all';
      const tagString = parts.slice(collectionIndex + 2).join('/');
      const tags = tagString ? tagString.split('+').filter(Boolean) : [];
      return { handle, tags };
    }
  }
  
  
  /* =======================================================
     TOGGLE FILTER BY TAG
  ======================================================= */
  function initCkFilters() {
    const toggles = document.querySelectorAll('.ck-filter');
    if (!toggles.length) return;
  
    const normalizeTag = (val) =>
      val
        ? val
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '')
        : '';
  
    const currentPath = window.location.pathname;
    const currentTags = extractTagsFromPath(currentPath);
  
    toggles.forEach((toggle) => {
      const tag = normalizeTag(toggle.dataset.filter);
      toggle.checked = currentTags.includes(tag);
    });
  
    toggles.forEach((toggle) => {
      toggle.addEventListener('change', () => {
        const tag = normalizeTag(toggle.dataset.filter);
        if (!tag) return;
  
        const currentUrl = new URL(window.location.href);
        const collectionInfo = extractCollectionInfo(currentUrl.pathname);
        let tags = currentTags.slice();
  
        if (toggle.checked) {
          if (!tags.includes(tag)) tags.push(tag);
        } else {
          tags = tags.filter((t) => t !== tag);
        }
  
        let newPath = `/collections/${collectionInfo.handle}`;
        if (tags.length) newPath += '/' + tags.join('+');
        const newUrl = newPath + currentUrl.search + '#ck-collection-filters';
  
        // console.log('[CK Filters] Redirect →', newUrl);
        window.location.href = newUrl;
      });
    });
  
    function extractCollectionInfo(path) {
      const parts = path.split('/').filter(Boolean);
      const collectionIndex = parts.indexOf('collections');
      return {
        handle: parts[collectionIndex + 1] || '',
      };
    }
  
    function extractTagsFromPath(path) {
      const parts = path.split('/').filter(Boolean);
      const collectionIndex = parts.indexOf('collections');
      const tagString = parts.slice(collectionIndex + 2).join('/');
      return tagString ? tagString.split('+').filter(Boolean) : [];
    }
  }
  
  /* =======================================================
     DYNAMIC DRAWER + COUNT + BADGE HANDLING
  ======================================================= */
  document.addEventListener('DOMContentLoaded', () => {
      // console.log('[CK Filters] Debug mode active');
    
      const countEl =
        document.querySelector('.ck-collection-filters__count') ||
        document.querySelector('.collection-product-count') ||
        document.querySelector('.product-count') ||
        document.querySelector('.collection-count');
    
      const drawer = document.querySelector('#FacetDrawer');
      if (!drawer) {
        // console.warn('[CK Filters] No #FacetDrawer found on page.');
        return;
      }
    
      // console.log('[CK Filters] Drawer ready → #FacetDrawer');
    
      function getActiveFacets() {
        const facets = {};
        const facetGroups = drawer.querySelectorAll('[data-filter-handle]');
    
        facetGroups.forEach((group) => {
          const handle = group.dataset.filterHandle;
          const checkedInputs = group.querySelectorAll('input[type="checkbox"]:checked');
    
          if (checkedInputs.length > 0) {
            facets[handle] = Array.from(checkedInputs).map((input) => input.value);
          }
        });
    
        return facets;
      }
    
      function updateBadges() {
        const activeFacets = getActiveFacets();
        // console.log('[CK Filters] Active facets snapshot:', activeFacets);
      
        const buttons = document.querySelectorAll('.ck-filter-btn[data-filter-handle]');
        buttons.forEach((btn) => {
          const handle = btn.dataset.filterHandle;
          const activeValues = activeFacets[handle] || [];
          let badge = btn.querySelector('.ck-filter-count__wrapper');
          let span = badge ? badge.querySelector('.ck-filter-count') : null;
      
          if (activeValues.length > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'ck-filter-count__wrapper';
              span = document.createElement('span');
              span.className = 'ck-filter-count';
              badge.appendChild(span);
              btn.appendChild(badge);
            }
      
            span.textContent = activeValues.length;
      
            badge.classList.add('active');
            btn.classList.add('active');
      
            // console.log(`[CK Filters] Updated badge for ${handle} → ${activeValues.length}`);
          } else {
            if (badge) badge.remove();
            btn.classList.remove('active');
            // console.log(`[CK Filters] Cleared badge for ${handle}`);
          }
        });
      }
      
  
      drawer.addEventListener('toggle', async () => {
        const isOpen = drawer.hasAttribute('open');
    
        if (!isOpen) {
          // console.log('[CK Filters] Drawer closed → fetching latest counts...');
          try {
            const res = await fetch(window.location.href, {
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
            });
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
    
            const newCountEl =
              doc.querySelector('.ck-collection-filters__count') ||
              doc.querySelector('.collection-product-count') ||
              doc.querySelector('.product-count') ||
              doc.querySelector('.collection-count');
    
            if (newCountEl && countEl) {
              const newText = newCountEl.textContent.trim();
              countEl.textContent = newText;
              // console.log('[CK Filters] Updated total products count →', newText);
            }
    
            updateBadges();
          } catch (err) {
            console.warn('[CK Filters] ⚠️ Failed to update counts:', err);
          }
        }
      });
    
      drawer.addEventListener('change', (e) => {
        if (e.target.matches('input[type="checkbox"]')) {
          const facet = e.target.closest('[data-filter-handle]');
          const handle = facet?.dataset.filterHandle;
          const checked = facet?.querySelectorAll('input[type="checkbox"]:checked')?.length || 0;
    
          // console.log(`[CK Filters] ${handle} changed → ${checked} selected`);
          updateBadges();
        }
      });
    
      updateBadges();
    });
    
  
  /* =======================================================
     SHOPIFY AJAX FACET RELOAD HANDLER
  ======================================================= */
  document.addEventListener('shopify:section:load', () => {
    // console.log('[CK Filters] Facet section reloaded — reinitializing filters.');
    initCkFilters();
  });
  
  /* =======================================================
     RESET ALL FILTERS
  ======================================================= */
  document.addEventListener('DOMContentLoaded', () => {
      const drawer = document.querySelector('#FacetDrawer');
      if (!drawer) return;
    
      const form = drawer.querySelector('form.facet-form');
      const resetButtons = drawer.querySelectorAll('.ck-reset-filters');
      const facets = drawer.querySelectorAll('.ck-details[data-filter-handle]');
    
      function getActiveFacet() {
        return drawer.querySelector('.ck-details.active[data-filter-handle]');
      }
    
      function hasSelectedFilters(facet) {
        return (
          facet &&
          facet.querySelectorAll('input[type="checkbox"]:checked').length > 0
        );
      }
    
      function updateResetButtons() {
        const activeFacet = getActiveFacet();
        const activeHandle = activeFacet?.dataset.filterHandle;
    
        resetButtons.forEach((btn) => {
          const handle = btn.dataset.filterHandle;
          const isVisible =
            activeHandle === handle && hasSelectedFilters(activeFacet);
    
          if (isVisible) {
            btn.classList.add('active');
            btn.classList.remove('hidden');
          } else {
            btn.classList.remove('active');
            btn.classList.add('hidden');
          }
        });
      }
    
      document.querySelectorAll('.ck-filter-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const handle = btn.dataset.filterHandle;
    
          // mark facet as active
          facets.forEach((facet) => facet.classList.remove('active'));
          const activeFacet = drawer.querySelector(
            `.ck-details[data-filter-handle="${handle}"]`
          );
          if (activeFacet) activeFacet.classList.add('active');
    
          updateResetButtons();
        });
      });
    
      drawer.addEventListener('change', (e) => {
        if (e.target.matches('input[type="checkbox"]')) {
          updateResetButtons();
        }
      });
    
      drawer.addEventListener('click', (e) => {
        const btn = e.target.closest('.ck-reset-filters.active');
        if (!btn) return;
    
        e.preventDefault();
        const handle = btn.dataset.filterHandle;
        const label = btn.dataset.filterLabel || '';
    
        // console.log(`[CK Filters] Reset clicked for ${handle} (${label})`);
    
        const facetGroup = drawer.querySelector(
          `.ck-details[data-filter-handle="${handle}"]`
        );
        if (facetGroup) {
          const checked = facetGroup.querySelectorAll('input[type="checkbox"]:checked');
          checked.forEach((cb) => (cb.checked = false));
        }
    
        if (!btn.classList.contains('ck-resetting')) {
          btn.classList.add('ck-resetting');
          const original = btn.textContent.trim();
          btn.textContent = `${original} …`;
    
          setTimeout(() => {
            btn.textContent = original;
            btn.classList.remove('ck-resetting');
          }, 1500);
        }
    
        if (form?.hasAttribute('update-on-change')) {
          form.dispatchEvent(new Event('input', { bubbles: true }));
          form.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          form.submit();
        }
    
        updateResetButtons();
      });
    
      updateResetButtons();
    });
  /* =======================================================
     CORRESPONDING FILTER TITLE
  ======================================================= */
  document.addEventListener('DOMContentLoaded', () => {
      const drawer = document.querySelector('#FacetDrawer');
      if (!drawer) return;
    
      const titles = drawer.querySelectorAll('.drawer__title[data-filter-handle]');
      const facets = drawer.querySelectorAll('.ck-details[data-filter-handle]');
      const buttons = document.querySelectorAll('.ck-filter-btn[data-filter-handle]');
    
      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const handle = btn.dataset.filterHandle;
    
          drawer.setAttribute('open', '');
    
          facets.forEach((facet) => facet.classList.remove('active'));
          const activeFacet = drawer.querySelector(`.ck-details[data-filter-handle="${handle}"]`);
          if (activeFacet) activeFacet.classList.add('active');
    
          titles.forEach((title) => title.classList.remove('active'));
          const activeTitle = drawer.querySelector(`.drawer__title[data-filter-handle="${handle}"]`);
          if (activeTitle) activeTitle.classList.add('active');
        });
      });
    
      drawer.addEventListener('toggle', () => {
        const isOpen = drawer.hasAttribute('open');
        if (!isOpen) {
          titles.forEach((title) => title.classList.remove('active'));
        }
      });
    });
    
    
  /* =======================================================
     DRAG ON DESKTOP
  ======================================================= */
    document.addEventListener('DOMContentLoaded', () => {
      const scrollers = document.querySelectorAll('.ck-collection-filters__submenu');
    
      scrollers.forEach((scroller) => {
        let isDown = false;
        let startX;
        let scrollLeft;
    
        scroller.addEventListener('mousedown', (e) => {
          isDown = true;
          scroller.classList.add('dragging');
          startX = e.pageX - scroller.offsetLeft;
          scrollLeft = scroller.scrollLeft;
        });
    
        scroller.addEventListener('mouseleave', () => {
          isDown = false;
          scroller.classList.remove('dragging');
        });
    
        scroller.addEventListener('mouseup', () => {
          isDown = false;
          scroller.classList.remove('dragging');
        });
    
        scroller.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - scroller.offsetLeft;
          const walk = (x - startX) * 1;
          scroller.scrollLeft = scrollLeft - walk;
        });
      });
    });
    
    
  /* =======================================================
     TOGGLES TOOLTIPS
  ======================================================= */
  
  document.addEventListener('DOMContentLoaded', () => {
      const infos = document.querySelectorAll('.ck-filter-info');
      const wrapper = document.querySelector('.ck-collection-filters__toggles');
    
      infos.forEach((info) => {
        info.addEventListener('mouseenter', () => {
          if (window.matchMedia('(hover: hover)').matches) {
            info.classList.add('active');
          }
        });
    
        info.addEventListener('mouseleave', () => {
          info.classList.remove('active');
          wrapper?.classList.remove('active');
        });
    
        info.addEventListener('click', (e) => {
          if (!window.matchMedia('(hover: hover)').matches) {
            e.preventDefault();
    
            infos.forEach((el) => el.classList.remove('active'));
    
            const isActive = info.classList.toggle('active');
            if (isActive) {
              wrapper?.classList.add('active');
            } else {
              wrapper?.classList.remove('active');
            }
          }
        });
      });
    
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.ck-filter-info')) {
          infos.forEach((el) => el.classList.remove('active'));
          wrapper?.classList.remove('active');
        }
      });
    });
    
/* =======================================================
    SORT INIT
======================================================= */

/*document.addEventListener('DOMContentLoaded', () => {
  const sortLinks = document.querySelectorAll('.ck-sort a');

  sortLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      const currentUrl = new URL(window.location.href);
      const currentSort = currentUrl.searchParams.get('sort_by');
      const clickedSort = new URL(link.href).searchParams.get('sort_by');

      if (currentSort === clickedSort) {
        e.preventDefault();
        currentUrl.searchParams.delete('sort_by');
        const newUrl = currentUrl.pathname + currentUrl.search + '#ck-collection-filters';
        window.location.href = newUrl;
      }
    });
  });
});*/
